import { AddressLinkType } from 'Modules'
import { useCallback, useState } from 'react'
import { useAccount } from 'wagmi'

import { Noti } from 'component/noti/toast'
import { CONFIRMATIONS_BLOCK, ContractStatusEnum } from 'constants/index'
import { useMarketPlaceContext } from 'context/marketplace/market-place-provider'
import { customErrorContract } from 'hooks/contract/use-contract-viem'
import { clientWallet, publicWallet } from 'libs/viem/config'
import { onCloseModalProcessing, onOpenModalProcessing } from 'stores/modal.store'

export const useMarketPlaceAction = ({
  contractAddress,
  onChange,
  onError,
}: {
  contractAddress: AddressLinkType
  onChange?: (checked: boolean) => Promise<void>
  onError?: (checked: boolean) => void
}) => {
  const [loading, setLoading] = useState(false)

  const { address } = useAccount()

  const { isContractManager, contract } = useMarketPlaceContext()

  /**
   * handle enable marketplace
   */
  const handleEnableMarketPlace = useCallback(
    async (checked: boolean) => {
      try {
        setLoading(true)
        onOpenModalProcessing()
        if (!contract) {
          Noti('error', 'Please add contract address marketplace', 3000)
          onError?.(checked)
          return
        }
        if (!contractAddress) {
          Noti('error', 'Please add contract address token', 3000)
          onError?.(checked)
          return
        }
        if (!isContractManager) {
          Noti('error', 'Please check permission', 3000)
          onError?.(checked)
          return
        }

        let request = null
        if (checked) {
          const { request: requestAddSimulate } = await contract.simulate.addNFTToWhitelist(
            [contractAddress],
            {
              account: address,
            }
          )
          request = requestAddSimulate
        } else {
          const { request: requestRemoveSimulate } = await contract.simulate.removeNFTFromWhitelist(
            [contractAddress],
            {
              account: address,
            }
          )
          request = requestRemoveSimulate
        }
        if (!request) {
          Noti('error', 'Error, Please check to late!', 3000)
          onError?.(checked)
          return
        }
        const txHash = await clientWallet?.writeContract(request)
        if (txHash) {
          const receipt = await publicWallet.waitForTransactionReceipt({
            hash: txHash,
            confirmations: CONFIRMATIONS_BLOCK,
          })

          if (receipt.status === ContractStatusEnum.SUCCESS) {
            if (onChange) {
              await onChange(checked)
            }
            Noti('success', `Success ${checked ? 'apply' : 'remove'} to marketplace`, 3000)
          }
        }
      } catch (error: any) {
        setLoading(false)
        onCloseModalProcessing()
        const errorMessage = customErrorContract(error)
        Noti('error', errorMessage, 3000)
        onError?.(checked)
      } finally {
        setLoading(false)
        onCloseModalProcessing()
      }
    },
    [contract, contractAddress, isContractManager, onError, address, onChange]
  )

  return {
    loading,
    isContractManager,
    handleEnableMarketPlace,
  }
}
